import { render, staticRenderFns } from "./CompanyChangePlanFree.vue?vue&type=template&id=360a0de4&scoped=true"
import script from "./CompanyChangePlanFree.vue?vue&type=script&lang=js"
export * from "./CompanyChangePlanFree.vue?vue&type=script&lang=js"
import style0 from "./CompanyChangePlanFree.vue?vue&type=style&index=0&id=360a0de4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a0de4",
  null
  
)

export default component.exports